<div class="pie-chart-container">
  @if (pieChartData()) {
    <div [@fadeIn]>
      <canvas
        baseChart
        [type]="pieChartType()"
        [data]="pieChartData() || undefined"
        [options]="pieChartOptions()"
        [plugins]="pieChartPlugins()"
      ></canvas>
    </div>
  } @else {
    <div class="no-data">No data available</div>
  }
</div>
